import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { environment } from 'src/environments/environment';
import { Helpers } from 'projects/training-calendar/src/app/helpers';
import { FileService } from './document/file.service';
import { STRING } from 'projects/common/src/app/types';
import { CurrentUserService } from '../current-user.service';
const defaultPaymentEndpoint = `/payment/pay`;

interface IRedirectURl {
	clientSuccessRedirectUrl: string;
	clientFailureRedirectUrl?: string;
}
@Injectable({ providedIn: 'root' })
export class PaymentService {

	constructor(private apiService: ApiService,
		private fileService: FileService,
		private currentUserService: CurrentUserService) {

	}

	// // makePaymentDone(subscriptionId: any, redirectUrl: string) {
	// makePaymentDone(details: any, redirectUrl: IRedirectURl, paymentEndpoint: string = defaultPaymentEndpoint) {
	// 	this._getPaymentAccessToken()
	// 		.subscribe(res => {
	// 			const accessToken = res.data;
	// 			redirectUrl.clientSuccessRedirectUrl = `${environment.clientHost}/${redirectUrl.clientSuccessRedirectUrl}`;
	// 			redirectUrl.clientFailureRedirectUrl = `${environment.clientHost}/${redirectUrl.clientFailureRedirectUrl}`;
	// 			Object.assign(details, redirectUrl);
	// 			const queryString = Helpers.serialize(details);
	// 			const endpoint = `${environment.paymentService}${paymentEndpoint}?accessToken=${accessToken}&${queryString}`;
	// 			// const endpoint = `${environment.paymentService}/payment/pay?redirectUrl=${encodedRedirectUrl}&subscriptionId=${subscriptionId}&accessToken=${accessToken}`;
	// 			window.location.assign(endpoint);
	// 		});

	// }

	makePaymentDoneRefact(tokenId: string, redirectUrl: string) {
		if (!tokenId || !redirectUrl) {
			console.warn('Token Id or Redirect URL is not present')
			return Promise.reject({
				invalidParameter: true
			})
		}
		this.currentUserService.updateToken().subscribe(data => {
			console.log('token updated')
			this._getPaymentAccessToken()
			.subscribe(res => {
				const accessToken = res.data;
				const queryString = Helpers.serialize({
					accessToken,
					tokenId,
					redirectUrl
				})
				const endpoint = `${environment.paymentService}/api/payment/pay?${queryString}`
				window.location.assign(endpoint);
			})
		})
	}

	deriveReceiptUrl(paymentDetail) {
		return (paymentDetail &&
			paymentDetail.billReceiptData &&
			paymentDetail.billReceiptData[paymentDetail.billReceiptData.length - 1] &&
			paymentDetail.billReceiptData[paymentDetail.billReceiptData.length - 1].awsPath) ||
			(paymentDetail && paymentDetail.receiptPath);
	}

	downloadReceipt(receiptPath) {
	// const receiptPath = payment.receiptPath;
		if (typeof receiptPath === STRING.OBJECT) {
			receiptPath = this.deriveReceiptUrl(receiptPath)
		}
		console.log(receiptPath)
		if (receiptPath) {
			this.fileService.downloadAttachedFile(receiptPath);
		}
	}

	_getInvoicesDownload(data) {
		const url = `${environment.paymentService}/api/payment/generateReceiptForPayment/`;
		return this.apiService.post(url, data);
	}

	getPaymentDetails(paymentId: string) {
		const url = `${environment.paymentService}/api/payment/user/${paymentId}`;
		return this.apiService.get(url);
	}

	tryPaymentAgain(paymentId: string) {
		// this._getIncompletePayment(paymentId)
		// 	.subscribe(res => {
		// 		const req = res && res.data && res.data.requestMetadata;
		// 		const subscriptionId = req.subscriptionId;
		// 		const clientSuccessRedirectUrl = req.clientSuccessRedirectUrl.split(environment.clientHost)[1];
		// 		const clientFailureRedirectUrl = req.clientFailureRedirectUrl.split(environment.clientHost)[1];
		// 		const filteredclientSuccessRedirectUrl = clientSuccessRedirectUrl.split('/').filter(h => h).join('/');
		// 		const filteredclientFailureRedirectUrl = clientFailureRedirectUrl.split('/').filter(h => h).join('/');
		// 		this.makePaymentDone({ subscriptionId }, {
		// 			clientSuccessRedirectUrl: filteredclientSuccessRedirectUrl,
		// 			clientFailureRedirectUrl: filteredclientFailureRedirectUrl
		// 		});
		// 		// this.makePaymentDone(subscriptionId, filteredRedirectURl);
		// 		// console.log(res)
		// 	}, err => {
		// 		console.log(err);
		// 	});
	}
	// _getInvoicesDownload(data) {
	// 	const url = `${environment.paymentService}/api/payment/generateReceiptForPayment/`;
	// 	return this.apiService.post(url, data);
	// }

	private _getIncompletePayment(paymentId) {
		const url = `${environment.paymentService}/api/payment/user/incompleted/${paymentId}`;
		return this.apiService.get(url);
	}

	private _getPaymentAccessToken() {
		return this.apiService.get(`${environment.paymentService}/api/payment/accessToken`);
	}

}
